/**
 * HOST
 */
export const HOST_TEST = "https://test-zhuangyou.shuwen.com";
export const HOST_PRE = "https://pre-vlog-zhuangyou.shuwen.com";
export const HOST_PROD = "https://vlog-zhuangyou.shuwen.com";

/**
 * GATEWAY
 */
export const HOST_GATEWAY_TEST = "https://test-vlog-api.shuwen.com";
export const HOST_GATEWAY_PRE = "https://pre-vlog-api.shuwen.com";
export const HOST_GATEWAY_PROD = "https://vlog-api.shuwen.com";
/**
 * STREAM
 */
export const HOST_STREAM_TEST = "https://test-vlog-stream.shuwen.com";
export const HOST_STREAM_PRE = "https://test-vlog-stream.shuwen.com";
export const HOST_STREAM_PROD = "https://vlog-stream.shuwen.com";

export const IS_DEV = ["localhost", "test-zhuangyou.shuwen.com", '10.23.102.136'].some(
  i => i === window.location.hostname
);

export const IS_PRE = ["pre-vlog-zhuangyou.shuwen.com"].some(
  i => i === window.location.hostname
);

export const IS_PROD = ["vlog-zhuangyou.shuwen.com"].some(
  i => i === window.location.hostname
);

// 一体机
export const IN_MACHINE = ["/machine"].some(
  i => window.location.pathname?.includes(i)
);

export const getHostConfig = () => {
  if (IS_DEV && !IN_MACHINE) {
    return ENV_S_HOST_2.TEST;
  }
  if (IS_PRE && !IN_MACHINE) {
    return ENV_S_HOST_2.PRE;
  }
  return ENV_S_HOST_2.PROD;
};

export const ENV_S_HOST_2 = {
  TEST: {
    env: "测试环境",
    host: HOST_TEST,
    stream: HOST_STREAM_TEST,
    gateway: {
      host: HOST_GATEWAY_TEST,
      accessKey: "Ah78twq2CtN1MPuq",
      secretKey: "7440acbafb2243ad8aef516b988ce421"
    }
  },
  PRE: {
    env: "预发环境",
    host: HOST_PRE,
    stream: HOST_STREAM_PRE,
    gateway: {
      host: HOST_GATEWAY_PRE,
      accessKey: "5JvipvnOqFkwsRO8",
      secretKey: "2eec83eb66b548838520c78b6079cc25"
    }
  },
  PROD: {
    env: "线上环境",
    host: HOST_PROD,
    stream: HOST_STREAM_PROD,
    gateway: {
      host: HOST_GATEWAY_PROD,
      accessKey: "7luLwxmj5saoEJP7",
      secretKey: "bed984db2e754044885526fe4761f9ec"
    }
  }
};

export const GATE_WAY_API_PREFIX = [
  "/vlog-smallapp",
  "/vlog-basic",
  "/vlog-activity"
];

export const isGatewayAPI = (url: string) => {
  return GATE_WAY_API_PREFIX.some(i => url.startsWith(i));
};

export const XfConfig = {
  APPID: '51f6cc8b',
  APISecret: 'MjI4NmUyY2MzNzA5OGVlNjRiYTM1MmNh',
  APIKey: '8b81852aa601920b96e0c63c1993854b',
};

export const wakeUpConfig = {
  APPID: '05365f53',
  APISecret: 'OTFkZGRiMDk3MGEwMjI2ODcyZDkxZTJk',
  APIKey: '4b78311eae7387466ee085d8408230d7',
};

// 阿里云 oss asr文件上传前缀
export const recordAudioPrefix = () => {
  if (IS_DEV) {
    return 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/qabot-platform/asr/test/';
  }
  return 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/qabot-platform/asr/';
};

// 阿里云 oss 人脸文件上传前缀
export const recordFacePrefix = () => {
  if (IS_DEV) {
    return 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/qabot-platform/face/test/';
  }
  return 'https://idst-video-img.oss-cn-hangzhou.aliyuncs.com/qabot-platform/face/';
};
